import { EVENT_BG } from "./assets";

// Upcoming + past events. Mirrors structure from casabala.com/Events.html.
// The flagship event (id=1) has a full detail page; others are teasers.
export const eventsData = [
  // ============================================
  // ПОСЛЕДНИ СЪБИТИЯ (най-новите отгоре)
  // ============================================
  
  // ФИНАЛ - 19 ЮЛИ 2026
  {
    id: "11",
    slug: "football-night-final-19-july-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Футболна вечер - ФИНАЛ",
    titleEn: "Football Night - FINAL",
    dateBg: "19 юли 2026 г., 19:00 ч.",
    dateEn: "19 July 2026, 19:00",
    shortBg: "ФИНАЛ - събиране от 18:00 ч., вечеря от 20:00 ч., изненада за позналия резултата, музика и водещ.",
    shortEn: "FINAL - gathering from 18:00, dinner from 20:00, surprise for the winner, music and host.",
    image: EVENT_BG.e11,
    detailImage: EVENT_BG.e11_detail,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    musicBg: "Специален гост - музика на живо",
    musicEn: "Special guest - live music",
    includesBg: "Вечеря, музика, водещ и участие в събитието",
    includesEn: "Dinner, music, host and event participation",
    extraBg: "Изненада за позналия резултата на финала!",
    extraEn: "Surprise for the one who guesses the final result!",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast.",
    priceLabelBg: "Цена на човек",
    priceLabelEn: "Price per person",
    priceBg: "€ 99.90",
    priceEn: "€ 99.90",
    programBg: [
      "19:00 — ФИНАЛ - събиране",
      "20:00 — Вечеря",
      "22:00 — ФИНАЛ",
      "След мача — Изненада за позналия резултата!",
    ],
    programEn: [
      "19:00 — FINAL - gathering",
      "20:00 — Dinner",
      "22:00 — FINAL",
      "After the match — Surprise for the winner!",
    ],
    priceBg: "€ -",
    priceEn: "€ -",
  },

  // ПОЛУФИНАЛ - 15 ЮЛИ 2026
  {
    id: "10",
    slug: "football-night-semi-final-15-july-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Футболна вечер - Полуфинал",
    titleEn: "Football Night - Semi-Final",
    dateBg: "15 юли 2026 г., 20:00 ч.",
    dateEn: "15 July 2026, 20:00",
    shortBg: "Полуфинал - вечеря от 20:00 ч., мач от 22:00 ч.",
    shortEn: "Semi-Final - dinner from 20:00, match from 22:00.",
    image: EVENT_BG.e10,
    detailImage: EVENT_BG.e10,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    includesBg: "Резервация предварително",
    includesEn: "Reservation in advance",
    extraBg: "",
    extraEn: "",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast.",
    priceLabelBg: "Резервация",
    priceLabelEn: "Reservation",
    priceBg: "Безплатно",
    priceEn: "Free",
    programBg: [
      "20:00 — Отваряне на вратите",
      "22:00 — Полуфинал",
    ],
    programEn: [
      "20:00 — Doors open",
      "22:00 — Semi-Final",
    ],
    menu: [],
    priceBg: "Безплатно",
    priceEn: "Free",
  },

  // ПОЛУФИНАЛ - 14 ЮЛИ 2026
  {
    id: "9",
    slug: "football-night-semi-final-14-july-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Футболна вечер - Полуфинал",
    titleEn: "Football Night - Semi-Final",
    dateBg: "14 юли 2026 г., 20:00 ч.",
    dateEn: "14 July 2026, 20:00",
    shortBg: "Полуфинал - вечеря от 20:00 ч., мач от 22:00 ч.",
    shortEn: "Semi-Final - dinner from 20:00, match from 22:00.",
    image: EVENT_BG.e9,
    detailImage: EVENT_BG.e9,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    includesBg: "Резервация предварително",
    includesEn: "Reservation in advance",
    extraBg: "",
    extraEn: "",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast.",
    priceLabelBg: "Резервация",
    priceLabelEn: "Reservation",
    priceBg: "Безплатно",
    priceEn: "Free",
    programBg: [
      "20:00 — Отваряне на вратите",
      "22:00 — Полуфинал",
    ],
    programEn: [
      "20:00 — Doors open",
      "22:00 — Semi-Final",
    ],
    menu: [],
    priceBg: "Безплатно",
    priceEn: "Free",
  },

  // ФРАНЦИЯ vs МАРОКО - 9 ЮЛИ 2026
  {
    id: "8",
    slug: "france-morocco-night-9-july-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Франция vs Мароко",
    titleEn: "France vs Morocco",
    dateBg: "9 юли 2026 г., 20:30 ч.",
    dateEn: "9 July 2026, 20:30",
    shortBg: "Футболна вечер с мача Франция vs Мароко.",
    shortEn: "Football evening with the match France vs Morocco.",
    image: EVENT_BG.e8,
    detailImage: EVENT_BG.e8,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    includesBg: "Резервация предварително",
    includesEn: "Reservation in advance",
    extraBg: "",
    extraEn: "",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast.",
    priceLabelBg: "Резервация",
    priceLabelEn: "Reservation",
    priceBg: "Безплатно",
    priceEn: "Free",
    programBg: [
      "20:30 — Отваряне на вратите",
      "23:00 — Мач: Франция vs Мароко",
    ],
    programEn: [
      "20:30 — Doors open",
      "23:00 — Match: France vs Morocco",
    ],
    menu: [],
    priceBg: "Безплатно",
    priceEn: "Free",
  },

  // ФУТБОЛНА ВЕЧЕР - 7 ЮЛИ 2026
  {
    id: "7",
    slug: "football-night-7-july-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Футболна вечер",
    titleEn: "Football Night",
    dateBg: "7 юли 2026 г., 18:00 ч.",
    dateEn: "7 July 2026, 18:00",
    shortBg: "Футболна вечер с мачовете Аржентина vs Египет (19:00) и Швейцария vs Колумбия (23:00).",
    shortEn: "Football evening with matches Argentina vs Egypt (19:00) and Switzerland vs Colombia (23:00).",
    image: EVENT_BG.e7,
    detailImage: EVENT_BG.e7_detail,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    includesBg: "Резервация предварително",
    includesEn: "Reservation in advance",
    extraBg: "",
    extraEn: "",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast.",
    priceLabelBg: "Резервация",
    priceLabelEn: "Reservation",
    priceBg: "Безплатно",
    priceEn: "Free",
    programBg: [
      "18:00 — Отваряне на вратите",
      "19:00 — Мач: Аржентина vs Египет",
      "23:00 — Мач: Швейцария vs Колумбия",
    ],
    programEn: [
      "18:00 — Doors open",
      "19:00 — Match: Argentina vs Egypt",
      "23:00 — Match: Switzerland vs Colombia",
    ],
    menu: [],
    priceBg: "Безплатно",
    priceEn: "Free",
  },

  // ПОРТУГАЛСКА ФУТБОЛНА ВЕЧЕР - 17 ЮНИ 2026
  {
    id: "6",
    slug: "portugal-night-17-june-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Португалска футболна вечер",
    titleEn: "Portuguese Football Evening",
    dateBg: "17 юни 2026 г., 19:00 ч.",
    dateEn: "17 June 2026, 19:00",
    shortBg: "Португалия vs ДР Конго · Автентично португалско меню, специален гост Шкумбата и жива футболна атмосфера.",
    shortEn: "Portugal vs DR Congo · Authentic Portuguese menu, special guest Shkumbata and a live football atmosphere.",
    image: EVENT_BG.e6,
    detailImage: EVENT_BG.e6_detail,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    musicBg: "Тематична музика",
    musicEn: "Themed music",
    includesBg: "Welcome drink, 4-степенно португалско меню и участие в събитието",
    includesEn: "Welcome drink, 4-course Portuguese menu and event participation",
    extraBg: "В полувремето специална дискусия с гостите — споделете очакванията си за мача Португалия vs ДР Конго!",
    extraEn: "Half-time discussion with guests — share your thoughts on the Portugal vs DR Congo match!",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо. Залата е за пушачи.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast. The hall is for smokers.",
    priceLabelBg: "Цена на човек",
    priceLabelEn: "Price per person",
    priceBg: "€ 86.90",
    priceEn: "€ 86.90",
    programBg: [
      "Специален гост: Шкумбата",
      "19:00 — Отваряне на вратите",
      "19:00 – 19:30 — Вечерята започва",
      "20:00 — Мач: Португалия vs ДР Конго",
      "Полувреме — Дискусия с гостите",
    ],
    programEn: [
      "Special guest: Shkumbata",
      "19:00 — Doors open",
      "19:00 – 19:30 — Dinner begins",
      "20:00 — Match: Portugal vs DR Congo",
      "Half-time — Discussion with guests",
    ],
    menu: [
      {
        sectionBg: "САЛАТА",
        sectionEn: "SALAD",
        nameBg: "Салата Алгарвия",
        nameEn: "Algarve Salad",
        descBg: "Свежи домати, краставици, финоко, маринована сьомга, портокалов дресинг, каперси и дижонски винегрет.",
        descEn: "Fresh tomatoes, cucumbers, fennel, marinated salmon, orange dressing, capers, and Dijon vinaigrette.",
      },
      {
        sectionBg: "ПРЕДЯСТИЕ",
        sectionEn: "STARTER",
        nameBg: "Ризото с октопод",
        nameEn: "Octopus Risotto",
        descBg: "Кремообразен ориз с октопод, пармезан, масло, лимон, бяло вино и пресен магданоз.",
        descEn: "Creamy rice with octopus, Parmesan cheese, butter, lemon, white wine and fresh parsley.",
      },
      {
        sectionBg: "ОСНОВНО ЯСТИЕ",
        sectionEn: "MAIN COURSE",
        nameBg: "Филе от треска",
        nameEn: "Cod Fillet",
        descBg: "Поднесено с картофена салата с червени и жълти чушки и гуазето от вонголе.",
        descEn: "Served with potato salad, red and yellow peppers, and vongole guazzetto.",
      },
      {
        sectionBg: "ДЕСЕРТ",
        sectionEn: "DESSERT",
        nameBg: "Пащял де ната",
        nameEn: "Pastel de Nata",
        descBg: "Иконата на португалските сладкиши с бутер тесто и богат яйчен крем, с прекрасни аромати на лимон и канела.",
        descEn: "The iconic Portuguese pastry with flaky puff pastry and rich egg custard, delicately flavored with lemon and cinnamon.",
      },
    ],
    priceBg: "€ 86.90",
    priceEn: "€ 86.90",
  },

  // ФРЕНСКА ВЕЧЕР - 16 ЮНИ 2026
  {
    id: "5",
    slug: "french-night-16-june-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Френска вечер",
    titleEn: "French Evening",
    dateBg: "16 юни 2026 г., 19:30 ч.",
    dateEn: "16 June 2026, 19:30",
    shortBg: "Футбол, шампанско, изискана вечеря и музика на живо. Франция vs Сенегал.",
    shortEn: "Football, champagne, exquisite dinner and live music. France vs Senegal.",
    image: EVENT_BG.e5,
    detailImage: EVENT_BG.e5_detail,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    musicBg: "Яна Каруба и Boyana Violin",
    musicEn: "Yana Carrubba and Boyana Violin",
    includesBg: "Welcome Drink: TAITTINGER Limited Edition FIFA World Cup 2026™, 4-степенно меню, селекция от Champagne Taittinger и френски вина",
    includesEn: "Welcome Drink: TAITTINGER Limited Edition FIFA World Cup 2026™, 4-course menu, selection of Champagne Taittinger and French wines",
    extraBg: "Представяне на Champagne Taittinger и специално включване на живо от Щатите на член от фамилията Taittinger. В полувремето ще се проведе специална дискусия с изненадващ специален гост.",
    extraEn: "Presentation of Champagne Taittinger and a live appearance from the USA by a member of the Taittinger family. A special discussion with a surprise guest will take place during half-time.",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо. Залата е за пушачи.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast. The hall is for smokers.",
    priceLabelBg: "Цена на човек",
    priceLabelEn: "Price per person",
    priceBg: "€ 89.90",
    priceEn: "€ 89.90",
    programBg: [
      "Жива музика: Яна Каруба и Boyana Violin",
      "19:30 ч. — Welcome Drink · TAITTINGER Limited Edition FIFA World Cup 2026™",
      "19:30 - 20:00 — Представяне на Champagne Taittinger и специално включване на живо от Щатите на член от фамилията Taittinger",
      "20:00 ч. — Вечеря",
      "22:00 ч. — Мач: Франция vs Сенегал",
      "Полувреме — Специална дискусия с изненадващ специален гост",
    ],
    programEn: [
      "Live music: Yana Carrubba and Boyana Violin",
      "19:30 — Welcome Drink · TAITTINGER Limited Edition FIFA World Cup 2026™",
      "19:30 — 20:00 Presentation of Champagne Taittinger and a live appearance from the USA by a member of the Taittinger family",
      "20:00 — Dinner",
      "22:00 — Match: France vs Senegal",
      "Half-time — Special discussion with a surprise guest",
    ],
    menu: [
      {
        sectionBg: "САЛАТА",
        sectionEn: "SALAD",
        nameBg: "Салата Нисоаз",
        nameEn: "Nicoise Salad",
        descBg: "Класическа салата Нисоаз с прясно филе от риба тон, зелен фасул, варени картофи, черни домати, черни маслини и свеж микс салати, овкусени с френски акценти и средиземноморска лекота.",
        descEn: "Classic Nicoise salad with fresh tuna fillet, green beans, boiled potatoes, black tomatoes, black olives and fresh mixed greens, flavoured with French accents and Mediterranean lightness.",
      },
      {
        sectionBg: "ПРЕДЯСТИЕ",
        sectionEn: "STARTER",
        nameBg: "Домашна паста талиолини с трюфелов сос",
        nameEn: "Homemade Tagliolini with Truffle Sauce",
        descBg: "Домашна паста талиолини с деликатен трюфелов сос.",
        descEn: "Homemade tagliolini with delicate truffle sauce.",
      },
      {
        sectionBg: "ОСНОВНО ЯСТИЕ",
        sectionEn: "MAIN COURSE",
        nameBg: "Лаврак с марсилски рибен сос",
        nameEn: "Sea Bass with Marseille Fish Sauce",
        descBg: "Лаврак с марсилски рибен сос, бавно готвени картофи фондант и боб касуле.",
        descEn: "Sea bass with Marseille fish sauce, slow-cooked fondant potatoes and cassoulet beans.",
      },
      {
        sectionBg: "ДЕСЕРТ",
        sectionEn: "DESSERT",
        nameBg: "Лимонов тарт с меренг и плодове",
        nameEn: "Lemon Tart with Meringue and Fresh Fruits",
        descBg: "Лимонов тарт с меренг и пресни плодове.",
        descEn: "Lemon tart with meringue and fresh fruits.",
      },
    ],
    priceBg: "€ 89.90",
    priceEn: "€ 89.90",
  },

  // ИСПАНСКА ВЕЧЕР - 15 ЮНИ 2026
  {
    id: "1",
    slug: "spain-night-15-june-2026",
    upcoming: false,
    badge: "2026",
    titleBg: "Испанска вечер",
    titleEn: "Spanish Night",
    dateBg: "15 юни 2026 г., 18:30 ч.",
    dateEn: "15 June 2026, 18:30",
    shortBg: "Тематична испанска вечер с авторско меню и жива музика.",
    shortEn: "A themed Spanish evening with a chef's menu and live music.",
    image: EVENT_BG.e4,
    detailImage: EVENT_BG.e4_detail,
    place: 'бул. "Симеоновско шосе" 4, София',
    placeEn: "4 Simeonovsko Shose Blvd, Sofia",
    musicBg: "Испанска тематична музика — специален гост",
    musicEn: "Spanish themed music — special guest",
    includesBg: "Welcome drink, 3-степенно меню и участие в събитието",
    includesEn: "Welcome drink, 3-course menu and event participation",
    extraBg: "Дискусия с гостите на полувремето — споделете очакванията си за мача Испания vs Кабо Верде!",
    extraEn: "Half-time discussion with guests — share your thoughts on the Spain vs Cape Verde match!",
    warningTitleBg: "МЕСТАТА СА ОГРАНИЧЕНИ!",
    warningTitleEn: "LIMITED SEATS!",
    warningBodyBg: "Задължително се обадете за резервация — местата за футболните вечери се запълват бързо.",
    warningBodyEn: "Reservation by phone is required — seats for football evenings fill up fast.",
    priceLabelBg: "Цена на човек",
    priceLabelEn: "Price per person",
    priceBg: "€ 88.10",
    priceEn: "€ 88.10",
    programBg: [
      "Жива испанска музика",
      "18:30 — Отваряне на вратите · Welcome Drink",
      "18:30 – 19:00 — Вечерята започва",
      "19:00 — Мач: Испания vs Кабо Верде",
      "Полувреме — Дискусия с гостите + специален гост",
    ],
    programEn: [
      "Live Spanish music",
      "18:30 — Doors open · Welcome Drink",
      "18:30 – 19:00 — Dinner begins",
      "19:00 — Match: Spain vs Cape Verde",
      "Half-time — Guest discussion + special guest",
    ],
    menu: [
      {
        sectionBg: "САЛАТА",
        sectionEn: "SALAD",
        nameBg: "Мурсианска салата",
        nameEn: "Murcian Salad",
        descBg: "Домати, тиквички, моркови, калмари, миди, яйце и босилек.",
        descEn: "Tomatoes, zucchini, carrots, calamari, mussels, egg and basil.",
      },
      {
        sectionBg: "ПРЕДЯСТИЯ",
        sectionEn: "STARTERS",
        nameBg: "Паеля",
        nameEn: "Paella",
        descBg: "Ориз карнароли, морски дарове, жълти чушки, чоризо, пилешко, лук, чесън, узо и подправки.",
        descEn: "Carnaroli rice, seafood, yellow peppers, chorizo, chicken, onion, garlic, ouzo and spices.",
      },
      {
        sectionBg: "ПРЕДЯСТИЯ",
        sectionEn: "STARTERS",
        nameBg: "Октопод по галисийски",
        nameEn: "Galician Octopus",
        descBg: "Пипала на плоча с чесън, краве масло и пресен босилек, бяло сухо вино, печен лимон, еспума от картофи и шафран, оризов чипс.",
        descEn: "Octopus on the plancha with garlic, butter and fresh basil, dry white wine, baked lemon, potato & saffron espuma, rice crisp.",
      },
      {
        sectionBg: "ОСНОВНО ЯСТИЕ",
        sectionEn: "MAIN COURSE",
        nameBg: "Плума Иберико",
        nameEn: "Pluma Ibérica",
        descBg: "Нежно иберийско свинско филе с пресни аспержи, броколи и салса верде.",
        descEn: "Tender Iberian pork tenderloin with fresh asparagus, broccoli and salsa verde.",
      },
      {
        sectionBg: "ДЕСЕРТ",
        sectionEn: "DESSERT",
        nameBg: "Крема Каталана",
        nameEn: "Crema Catalana",
        descBg: "Традиционен каталонски десерт с карамелизирана захар, нотки на портокал и канела.",
        descEn: "Traditional Catalan dessert with caramelised sugar, orange and cinnamon notes.",
      },
    ],
    priceBg: "€ 88.10",
    priceEn: "€ 88.10",
  },

  // ============================================
  // МИНАЛИ СЪБИТИЯ (по-стари, без детайли)
  // ============================================
  
  // ВЕЧЕР НА ДЖАЗА НА ЖИВО - 4
  {
    id: "4",
    upcoming: false,
    badge: "2026",
    titleBg: "Вечер на джаза на живо",
    titleEn: "Live Jazz Night",
    dateBg: "Минала",
    dateEn: "Past",
    shortBg: "Весела Морова и Яна Каруба",
    shortEn: "Vesela Morova & Yana Carrubba",
    image: EVENT_BG.e1,
  },
  
  // ПРОЛЕТ С ВКУС НА ЧЕРЕН ХАЙВЕР - 3
  {
    id: "3",
    upcoming: false,
    badge: "2026",
    titleBg: "Пролет с вкус на черен хайвер",
    titleEn: "Spring with the taste of black caviar",
    dateBg: "Минала",
    dateEn: "Past",
    shortBg: "",
    shortEn: "",
    image: EVENT_BG.e3,
  },
  
  // ВЕЧЕР НА ДЖАЗА НА ЖИВО - 2
  {
    id: "2",
    upcoming: false,
    badge: "2026",
    titleBg: "Вечер на джаза на живо",
    titleEn: "Live Jazz Night",
    dateBg: "Минала",
    dateEn: "Past",
    shortBg: "Цветелин Петков и Яна Каруба",
    shortEn: "Tsvetelin Petkov & Yana Carrubba",
    image: EVENT_BG.e2,
  },
];

export const getEventById = (id) => eventsData.find((e) => String(e.id) === String(id));
export const upcomingEvents = () => eventsData.filter((e) => e.upcoming);
export const pastEvents = () => eventsData.filter((e) => !e.upcoming);